import React from "react"
import LanguageEN from "./languageEN"
import LanguageAR from "./languageAR"
import LanguageHE from "./languageHE"

const Language = ({ 
  language
}) => {
 return <div>{language === "ar" ? <LanguageAR /> :language === "he"? <LanguageHE />: <LanguageEN />}</div>
}

export default Language
